import styled from 'styled-components';

export const SWrapper = styled.b`
  position: absolute;
  display: block;
  width: 200px;
  height: 200px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  overflow: hidden;
  pointer-events: none;

  img {
    top: 0px;
    left: 0px;
    position: absolute;
    height: 200px;
    width: 2800px;
    animation: DynamiteAnim 1s steps(14) forwards;
  }

  @media (max-width: 440px) {
    width: 150px;
    height: 150px;

    img {
      height: 150px;
      width: 2100px;
      animation: DynamiteAnimMobile 1s steps(14) forwards;
    }
  }
`;
